export default __webpack_public_path__ + "static/media/marcIcon.4a31fc5a.svg";